import React from 'react';
import PropTypes from 'prop-types';
import Testimonial from '../../components/Testimonial';
import { Container } from '../../components/Layout';

const HeroTestimonial = ({ input }) => {
  const { content, link, author_name, author_label, avatar } = input.primary;

  return (
    <Container isRichText hasBackground>
      <Testimonial
        authorName={author_name}
        authorLabel={author_label}
        link={link}
        avatar={avatar}
        center={false}
        content={content.html}
      />
    </Container>
  );
};

export default HeroTestimonial;

HeroTestimonial.propTypes = {
  input: PropTypes.object.isRequired,
};
